import { MetadataExplainDTO } from "../models/services/AgenticMetadataDTO";
import { PageMetadata } from "../models/PageMetadata";
import { formatFromMetadata } from "../../../astromark/format";

/**
 * Effective tags + expedition out of a metadata/explain response, plus the page `format` when the cascade has a `format`
 * scalar (`astromark` / `markdown-it`; see `src/astromark/format.ts`). Unknown or empty values are dropped.
 */
export function toPageMetadata(dto: MetadataExplainDTO | undefined | null): PageMetadata {
    const effective = dto?.effective;
    const seen = new Set<string>();
    const tags = (effective?.tags ?? [])
        .filter((t) => !!t?.name && !seen.has(t.name) && !!seen.add(t.name))
        .map((t) => ({ name: t.name, source: t.source ?? "own", confidence: t.confidence ?? undefined }));

    const raw = effective?.scalars?.["expedition"]?.value;
    const expedition = typeof raw === "string" && raw.trim() ? raw.trim() : undefined;

    return { tags, expedition, format: formatFromMetadata(dto) };
}
